import {BUSCAR_CONFIGURACOES_BILHETE} from '../../actions/configuracao-bilhete/configuracaoBilheteActions';
import { ALTERAR_DETALHAMENTO_CONFIGURACAO_BILHETE } from '../../actions/types';

const initialState = undefined;

const estadoInicial = {
  configuracoesBilhete: [],
  configuracoesBilheteTrecho: []
}

export default function reducerConfiguracaoBilhete (state = estadoInicial, action = initialState) {
  switch (action.type) {
    case BUSCAR_CONFIGURACOES_BILHETE: {

      if(action.payload.data) {        
        const configuracoesBilhete = action.payload.data.map((config, index) => Object.assign({}, config, { exibirDetalhe: false, indice: index }))
  
        if(configuracoesBilhete) {          
          return {
            ...state,
            configuracoesBilhete,
            configuracoesBilheteTrecho: concatArrayConfiguracoesBilhete(configuracoesBilhete)
          }
        }
      }
      return estadoInicial
    }

    case ALTERAR_DETALHAMENTO_CONFIGURACAO_BILHETE: {      
      const configuracao = action.payload;      
      const indice = state.configuracoesBilhete.findIndex(cb => cb.indice == configuracao.indice)
      const novoconfiguracao= Object.assign({}, configuracao, { exibirDetalhe: !configuracao.exibirDetalhe });
      const configuracoesBilhete = Object.assign([], state.configuracoesBilhete);
      configuracoesBilhete[indice] = novoconfiguracao;

      return {
        ...state,
        configuracoesBilhete,        
      };
      
    }

    default: {
      return state
    }
  }
}

function concatArrayConfiguracoesBilhete(array) {
  const arr = array.map(configuracao => configuracao.configuracaoBilhete)        
  let dados = [];
  arr.forEach(it => dados = dados.concat(it));
  
  return dados;
}
